<ng-container [formGroup]="formGroup">
  <mat-form-field class="settings-form__email-input">
    <mat-label>{{ "NOTIFICATION_SERVICE.EDIT.EMAIL_ADDRESS" | translate }}</mat-label>
    <input matInput formControlName="email" />
    <mat-icon matSuffix fontIcon="ec_edit"></mat-icon>
  </mat-form-field>
  <mat-divider big></mat-divider>
  <div class="settings-form__email-checkboxes">
    <div class="settings-form__checkbox-wrapper">
      <mat-checkbox formControlName="startEnd" [disableRipple]="true" [(indeterminate)]="indeterminate.startEnd">
        {{ "NOTIFICATION_SERVICE.EDIT.ACCOUNTING.NETZE_BW_DESCRIPTION" | translate }}
      </mat-checkbox>
      <app-badge [badge]="badges.start" [tooltipLabel]="badges.start.key"></app-badge>
    </div>
    <div class="settings-form__checkbox-wrapper">
      <mat-checkbox
        [disableRipple]="true"
        formControlName="intermediate"
        [(indeterminate)]="indeterminate.intermediate"
      >
        {{ "NOTIFICATION_SERVICE.EDIT.ACCOUNTING.INTERMEDIATE_DESCRIPTION" | translate }}
      </mat-checkbox>
      <app-badge [badge]="badges.intermediate" [tooltipLabel]="badges.intermediate.key"></app-badge>
    </div>
  </div>
</ng-container>
